import { render } from "./NavigationModal.vue?vue&type=template&id=a0674c76&scoped=true"
import script from "./NavigationModal.vue?vue&type=script&lang=js"
export * from "./NavigationModal.vue?vue&type=script&lang=js"

import "./NavigationModal.vue?vue&type=style&index=0&id=a0674c76&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0674c76"]])

export default __exports__